export default {
    sim_provider_delete_title: "Delete SIM Provider",
    sim_provider_delete_success_message: "The SIM Provider has been deleted",
    sim_provider_delete_error_message: "It is not possible to delete the SIM Provider",
    sim_provider_delete_confirm_message: "Are you sure you want to delete the SIM Provider?",
    sim_provider_delete_package_in_use: "The sim provider is linked to some sim provider account so it is not possible to delete it"
}